module.exports = __webpack_public_path__ + "img/banner2_2x.815326a4.png";